import { NgModule, ApplicationRef, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { RouterLink } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { removeNgStyles, createNewHosts } from '@angularclass/hmr';
// import { BootstrapModalModule } from 'ng2-bootstrap-modal';

import { AuthService } from './auth/auth.service';
import { routing } from './app.routing';
import { ApiServices } from './shared/services/api.services';
import { EventsService } from './shared/events/events.service';
import { Domain } from './shared/constants/domain.constants';
import { AppComponent } from './app.component';
import { PageNotFoundComponent } from './pagenotfound';
import { TermsOfUseComponent } from './terms-of-use/terms-of-use.component';
// import { PasswordChangedModalComponent } from './forgot.password/modal/modal.component';

import { ApiConstants } from './shared/constants/api.constants';
import { AppConstants } from './shared/constants/app.constants';

import { LoadingService } from './shared/loading/loading.service';
import { AlertService } from './shared/alerts/alerts.service';
import { LocalStorageService } from './shared/services/localStorage.service';

import { LoginComponent } from './login/login.component';
import { oLoginComponent } from './okta-login/okta-login.component';
import { BannerComponent } from './banner/banner.component';
import { RedirectComponent } from './okta-login/redirect.component';
import { LoginService } from './login/login.service';
import { oktaLoginService } from './okta-login/okta-login.service';

import { OktaForgotPassword } from './okta-forgot-password/okta-forgot-password.component';

import { OtpComponent } from './otp/otp.component';
import { OtpService } from './otp/otp.service';

import { MyFilterPipe } from './shared/filter/filter.pipe';
// import { ForgotPasswordComponent } from './forgot.password/forgot.password.component';
import { PasswordStrengthService } from './shared/services/form.validations/password.strength.service';
import { PasswordStrengthDirective } from './shared/components/password.strength/password.strength.directive';
import { PasswordStrengthComponent } from './shared/components/password.strength/password.strength.component';
import { ForgotPasswordService } from './forgot.password/forgot.password.service';
import { CookieService } from './shared/services/cookie.service';
import { GlobalErrorHandler } from './shared/error.handler';

import { BXBFooterComponent } from './bxb-footer/bxb-footer.component';
import { PrivacyShortComponent } from './privacy-short/privacy-short.component';
import { PrivacyFullComponent } from './privacy-full/privacy-full.component';
import { TenantComponent } from './tenant/tenant.component';
import { AccessDeniedComponent } from './shared/403/access.denied.component';
import { LogoutComponent } from './logout/logout.component';
import { MaintenanceMessageComponent } from './maintenance-message/maintenance-message.component';
import { MaintenanceMessageService } from './maintenance-message/maintenance-message.service';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ResetPasswordService } from './reset-password/reset-password.service';
import {
  OktaAuthModule
} from '@okta/okta-angular';

const config = {
  issuer: AppConstants.getIssuer(),
  redirectUri: Domain.bUrl + '/auth/authenticateOkta',
  clientId: AppConstants.getClientId()
};

@NgModule({
  imports: [
    BrowserModule,
    HttpModule,
    FormsModule,
    ReactiveFormsModule,
    routing,
    // BootstrapModalModule,
    OktaAuthModule.initAuth(config)
  ],
  declarations: [
    AppComponent,
    LoginComponent,
    oLoginComponent,
    BannerComponent,
    RedirectComponent,
    OktaForgotPassword,
    PageNotFoundComponent,
    TermsOfUseComponent,
    BXBFooterComponent,
    PrivacyShortComponent,
    PrivacyFullComponent,
    MyFilterPipe,
    // ForgotPasswordComponent,
    // PasswordChangedModalComponent,
    PasswordStrengthComponent,
    PasswordStrengthDirective,
    OtpComponent,
    TenantComponent,
    AccessDeniedComponent,
    LogoutComponent,
    MaintenanceMessageComponent,
    ResetPasswordComponent
  ],
  entryComponents: [
    PasswordStrengthComponent
  ],
  providers: [
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    },
    AuthService,
    ApiServices,
    ApiConstants,
    AppConstants,
    Domain,
    CookieService,
    LoadingService,
    AlertService,
    LoginService,
    oktaLoginService,
    EventsService,
    ForgotPasswordService,
    PasswordStrengthService,
    OtpService,
    LocalStorageService,
    RouterLink,
    MaintenanceMessageService,
    ResetPasswordService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(public appRef: ApplicationRef) { }
  hmrOnInit(store) {
    console.log('HMR store', store);
  }
  hmrOnDestroy(store) {
    let cmpLocation = this.appRef.components.map(cmp => cmp.location.nativeElement);
    // recreate elements
    store.disposeOldHosts = createNewHosts(cmpLocation);
    // remove styles
    removeNgStyles();
  }
  hmrAfterDestroy(store) {
    // display new elements
    store.disposeOldHosts();
    delete store.disposeOldHosts;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/app.module.ts